<template>
  <div class="wrapper-section-live ">
    <span class="group-user-icon mr-3">
      <svg
        width="15"
        height="12"
        viewBox="0 0 15 12"
        fill="none"
      >
        <g clip-path="url(#clip0_49190_11480)">
          <path d="M4.55874 6.28369C5.87985 6.28369 6.94912 5.21442 6.94912 3.89331C6.94912 2.5722 5.87985 1.50293 4.55874 1.50293C3.23762 1.50293 2.16835 2.5722 2.16835 3.89331C2.16835 5.21442 3.23762 6.28369 4.55874 6.28369ZM6.19785 6.96666H6.02071C5.57678 7.18009 5.08377 7.30814 4.55874 7.30814C4.0337 7.30814 3.54282 7.18009 3.09676 6.96666H2.91962C1.56222 6.96666 0.460938 8.06794 0.460938 9.42534V10.04C0.460938 10.6056 0.919805 11.0645 1.48539 11.0645H7.63208C8.19767 11.0645 8.65653 10.6056 8.65653 10.04V9.42534C8.65653 8.06794 7.55525 6.96666 6.19785 6.96666ZM10.7054 6.28369C11.8366 6.28369 12.7543 5.36596 12.7543 4.23479C12.7543 3.10363 11.8366 2.1859 10.7054 2.1859C9.57427 2.1859 8.65653 3.10363 8.65653 4.23479C8.65653 5.36596 9.57427 6.28369 10.7054 6.28369ZM11.7299 6.96666H11.6488C11.3521 7.0691 11.0384 7.1374 10.7054 7.1374C10.3725 7.1374 10.0587 7.0691 9.76208 6.96666H9.68098C9.24559 6.96666 8.84435 7.09258 8.49219 7.29534C9.01296 7.85665 9.3395 8.60151 9.3395 9.42534V10.2449C9.3395 10.2919 9.32883 10.3367 9.32669 10.3815H13.0958C13.6614 10.3815 14.1203 9.92262 14.1203 9.35704C14.1203 8.03593 13.051 6.96666 11.7299 6.96666Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_49190_11480">
            <rect
              width="13.6593"
              height="10.9275"
              fill="white"
              transform="translate(0.460938 0.692871)"
            />
          </clipPath>
        </defs>
      </svg>
    </span>
    <span class="font-bold  header-live-section">
      <span v-if="$slots.content">
        <slot name="content" />
      </span>
      <span v-else>
        Live now: {{ (userOnline || 0) | formatTotalPoint }}
        <svg
          class="ml-2"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
        >
          <circle
            cx="4.82422"
            cy="5"
            r="4.82422"
            fill="#33C173"
          />
        </svg>
      </span>

    </span>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'SectionLive',
  computed: {
    ...mapState({
      plan: (state) => state.currentUser.plan,
      userOnline: (state) => state.userOnline,
    }),
  },
}
</script>
<style lang="scss" scoped>

.wrapper-section-live{
  font-family: Nunito;
  display: flex;
 align-items: center;
}

.group-user-icon{
  border-radius: 6.261px;
  background: #686E7D;
  padding: 0px 7px 2px 7px
}

.header-live-section{
  font-family: Nunito;
  font-size: 19px;
  color: #fff;
}

</style>
